// extracted by mini-css-extract-plugin
export default {"hovered":"linkedin_hovered__Nq6ep","bw_circle":"linkedin_bw_circle__FCH0M","bw_stars":"linkedin_bw_stars__hsGRb","stars":"linkedin_stars__G0-RG"};